import clientPaths from './client';
import faPaths from './fa';
import adminPaths from './admin';

export function withId(path, params) {
  // withId('/account/:accountId', [account.id, 'accountId'])
  // withId('/account/:accountId/portfolio/:portfolioId', [[account.id, 'accountId'], [portfolio.id, 'portfolioId']])
  if (Array.isArray(params)) {
    if (Array.isArray(params?.[0])) {
      return params.reduce((newPath, param) => newPath.replace(`:${param[1]}`, param[0]), path);
    }

    return path.replace(`:${params[1]}`, params[0]);
  }

  // withId('/account/:accountId/portfolio/:portfolioId', { accountId: account.id, portfolioId})
  if (typeof params === 'object') {
    const entries = Object.entries(params);
    return entries.reduce((newPath, param) => newPath.replace(`:${param[0]}`, param[1]), path);
  }

  return path;
}

export { adminPaths, clientPaths, faPaths };
